import { T2LoadingService } from './../../../../trip2-theme/components/t2-loading/t2-loading.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { PostingService } from 'app/core/services/posting.service';
import { DateModel } from 'app/pages/A2-utils/ParentClass/parent-class-date.model';
import * as moment from 'moment';
import { IMyOptions } from 'mydatepicker';
import { Subscription } from 'rxjs/Subscription';
import { SweetAlertType } from 'sweetalert2';
import { PayorsService } from 'app/pages/payors/payors.service';
import { IBillingScheduleDetail, IScheduleAndEvent } from 'app/core/interfaces/billing.interface';
import { BilledService } from '../../billed/billed.service';

@Component({
  selector: 'app-autofill-posting-batch',
  templateUrl: './autofill-posting-batch.component.html',
  styleUrls: ['./autofill-posting-batch.component.scss']
})
export class AutofillPostingBatchComponent implements OnInit, OnDestroy {

  formPostingBatch: FormGroup;
  dateRangeExport: any;
  ptrDateBegin: DateModel;
  ptrDateEnd: DateModel;
  arrayCreditPayments: any[] = [];
  subscriptions: Subscription[] = [];
  payorSelectedList = [];
  payorList: { id: Number, itemName: string } [] = [];
  billingList: { id: Number, itemName: string } [] = [];
  dropdownSettings = {};
  dropdownSettingsBs = {};
  isSelectPayorDisabled: boolean;
  isSelectBillingStatusDisabled: boolean;
  balanceLessThan = false;
  billingScheduleList: IScheduleAndEvent[] = [];
  eventSchedule: IBillingScheduleDetail[] = [];

  myRDPOptions: IMyOptions = {
    dateFormat: 'mm-dd-yyyy',
    editableDateField: false
  };

  get titleForm(): string {
    return 'New Auto Fill';
  }

  get descriptionCtrl(): AbstractControl {
    return this.formPostingBatch.get('description');
  }

  get invoicebatchidCtrl(): AbstractControl {
    return this.formPostingBatch.get('invoicebatchid');
  }

  get creditSelectedIdCtrl(): AbstractControl {
    return this.formPostingBatch.get('creditSelectedId');
  }

  get payoridlistCtrl(): AbstractControl {
    return this.formPostingBatch.get('payoridlist');
  }

  get billingstatusidlistCtrl(): AbstractControl {
    return this.formPostingBatch.get('billingstatusidlist');
  }

  get balanceLessThanValueCtrl(): AbstractControl {
    return this.formPostingBatch.get('balancelessthanvalue');
  }

  get billingScheduleIdCtrl(): AbstractControl {
    return this.formPostingBatch.get('billingscheduleid');
  }

  get billingscheduledetailidsCtrl(): AbstractControl {
    return this.formPostingBatch.get('billingscheduledetailids');
  }

  get includeclosetripCtrl(): AbstractControl {
    return this.formPostingBatch.get('includeclosetrip');
  }

  constructor(private fb: FormBuilder,
    private postingService: PostingService,
    private sweetAlertHelper: SweetAlertHelper,
    private t2LoadingService: T2LoadingService,
    private payorService: PayorsService,
    private billedService: BilledService
    ) {
    this.createForm();
  }

  ngOnInit(): void {
    this.loadCreditPayments();
    this.settingDropDown();
    this.loadAllPayors();
    this.loadAllBillingStatus();
    this.getBillingSchedule();
    this.initSubscriptions();
  }

  initSubscriptions(): void {
    this.subscriptions.push(
      this.billingScheduleIdCtrl.valueChanges.subscribe((id: number) => {
        this.billingscheduledetailidsCtrl.setValue(null);
        this.eventSchedule = [];
        if (id) {
          this.getDetailsEvent(id);
        }
      })
    );
  }

  createForm(): void {
    this.formPostingBatch = this.fb.group({
      description:  [null, Validators.required],
      batchinfoid: null,
      invoicebatchid: null,
      creditSelectedId: [null, Validators.required],
      payoridlist: [[], Validators.required],
      billingstatusidlist: [[], Validators.required],
      balancelessthanvalue: null,
      billingscheduleid: [null],
      billingscheduledetailids: [null],
      includeclosetrip: false
    });
  }

  loadCreditPayments(): void {
    this.t2LoadingService.show();
    this.subscriptions.push(
      this.postingService.getAllCreditList().subscribe(
        (resp: any) => {
          if (resp) {
            this.arrayCreditPayments = resp;
          }
          this.t2LoadingService.hiden();
        },
        (error) => {
          this.t2LoadingService.hiden();
          this.sweetAlertHelper.createCustomAlert({
            title: 'Error',
            text: error.message,
            type: 'error',
          });
        }
      )
    );
  }

  onDateExportSelectedRange(event: any): void {
    if (event.beginJsDate === null || event.endJsDate === null) {
      this.ptrDateBegin = null;
      this.ptrDateEnd = null;
    } else {
      this.ptrDateBegin = this.formatDateRangeNgModel(event.beginDate).formattedOut;
      this.ptrDateEnd = this.formatDateRangeNgModel(event.endDate).formattedOut;
    }
  }

  formatDateRangeNgModel(dateRange: { day: any, month: any, year: any }): { formattedOut: any } {
    const DAY_FORMAT = (dateRange.day < 10) ? `0${dateRange.day}` : dateRange.day;
    const MONTH_FORMAT = (dateRange.month < 10) ? `0${dateRange.month}` : dateRange.month;
    const FORMAT_BEGIN = `${MONTH_FORMAT}/${DAY_FORMAT}/${dateRange.year}`;
    return { formattedOut: FORMAT_BEGIN};
  }

  submitRunAction(): void {
    this.t2LoadingService.show();
    const formData = this.formPostingBatch.getRawValue();

    if (formData.payoridlist.length && formData.billingstatusidlist.length) {

      if (this.ptrDateBegin === null && this.ptrDateEnd === null && formData.invoicebatchid === null) {
        this.t2LoadingService.hiden();
        this.sweetAlertHelper.createCustomAlert({
          title: 'Error',
          text: 'Date range and invoice number cannot be empty.',
          type: 'error',
        });
      } else {
        let payorIdList: any[];
        payorIdList = formData.payoridlist.map( (f: any) => f.id);

        let billingStList: any[];
        billingStList = formData.billingstatusidlist.map( (f: any) => f.id);

        const body = {
          description: formData.description,
          startdate: this.ptrDateBegin,
          enddate: this.ptrDateEnd,
          invoicebatchid: formData.invoicebatchid,
          payoridlist: payorIdList,
          billingstatusidlist: billingStList,
          billingscheduleids: formData.billingscheduleid,
          billingscheduledetailids: formData.billingscheduledetailids,
          creditselectedid: Number(formData.creditSelectedId),
          balancelessthanvalue: this.balanceLessThan ? Number(this.balanceLessThanValueCtrl.value) : null,
          includeclosetrip: formData.includeclosetrip
        };

        this.postingService.autoFill(body)
        .subscribe({
          next: (resp: any) => {
            let titleRes = 'Success';
            let typeMsg: SweetAlertType = 'success';
            if (resp.insertedrows === 0) {
              titleRes = 'No records inserted.';
              typeMsg = 'warning';
            }

            this.t2LoadingService.hiden();
            const objectModal = this.sweetAlertHelper.createCustomAlert({
              title: titleRes,
              text: `${resp.description}`,
              type: typeMsg,
            });

            if (resp.insertedrows > 0) {
              objectModal.then(() => {
                this.postingService.reloadMainGrid(true);
              });
            }
          },
          error: (error: any) => {
            this.t2LoadingService.hiden();
            this.sweetAlertHelper.createCustomAlert({
              title: 'Error',
              text: error.message,
              type: 'error',
            });
          }
        });
      }
    }
  }

  settingDropDown() {
    this.dropdownSettings = {
      singleSelection: false,
      text: 'Select payor',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: 'myclass custom-class',
      badgeShowLimit: 1
    };

    this.dropdownSettingsBs = {
      singleSelection: false,
      text: 'Select billing status',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: 'myclass custom-class',
      badgeShowLimit: 1
    };
  }

  cancel() {
    this.postingService.reloadMainGrid(false);
    this.postingService.setBatchCreditListSubject(null);
    this.postingService.setBatchInfoId(null);
    this.postingService.setArrayBatchcreditIds([]);
  }

  initDateRange() {
    const SUBTRACT_MONTH = moment().subtract(5, 'days').format('YYYY/DD/MM');
    const [ YEAR, DAY, MONTH ] = SUBTRACT_MONTH.split('/');
    const INIT = { year: Number(YEAR), month: Number(MONTH), day: Number(DAY) };
    const END = { year: moment().year(), month: (moment().month() + 1), day: moment().date() };
    this.setDateRange(INIT, END);
  }

  setDateRange(...args: any[]) {
    const [ INIT_DATE, END_DATE ] = args;
    this.dateRangeExport = {
      beginDate: { year: INIT_DATE.year, month: INIT_DATE.month, day: INIT_DATE.day },
      endDate: { year: END_DATE.year, month: END_DATE.month, day: END_DATE.day }
    };

    this.ptrDateBegin = this.formatDateRangeNgModel(this.dateRangeExport.beginDate).formattedOut;
    this.ptrDateEnd = this.formatDateRangeNgModel(this.dateRangeExport.endDate).formattedOut;
  }

  disabledButton(): boolean {
    let isValid = true;

    if ( (this.invoicebatchidCtrl.value !== null || (this.ptrDateBegin !== null && this.ptrDateEnd !== null) ) &&
        this.payoridlistCtrl.valid && this.descriptionCtrl.valid && this.creditSelectedIdCtrl.valid &&
        this.balanceLessThanValueCtrl.valid &&
        this.billingstatusidlistCtrl.valid) {
      isValid = false;
    }

    return isValid;
  }

  loadAllBillingStatus(): void {
    this.subscriptions.push(
      this.billedService.getBillingStatus().subscribe({
        next: (res) => {
          if (res && res.length) {
            res.forEach((rowBillingStatus: any) => {
              this.billingList.push({id: rowBillingStatus.billingstatusid, itemName: rowBillingStatus.description});
            });
          }
        },
        error: (error) => this.sweetAlertHelper.captureException(error)
      })
    );
  }

  loadAllPayors(): void {
    this.subscriptions.push(
      this.payorService.getPayorsAllPosting()
      .subscribe({
        next: (res: any) => {
          if (res.length) {
            res.forEach((rowPayor: any) => {
              this.payorList.push({id: rowPayor.payorid, itemName: rowPayor.description});
            });
          }
        },
        error: (er: any) => {
          this.t2LoadingService.hiden();
          this.resetFormAutoFill();

          this.sweetAlertHelper.createCustomAlert({
            title: 'Error',
            text: er.message,
            type: 'error',
          });
        }
      })
    );
  }

  getBillingSchedule(): void {
    this.subscriptions.push(
      this.billedService.getBillingSchedule().subscribe((res) => {
        if (res && res.length) {
          this.billingScheduleList = res;
        }
      }, (error) => this.sweetAlertHelper.captureException(error))
    );
  }

  getDetailsEvent(id: number) {
    const data = this.billingScheduleList.find(item => item.billingscheduleid === id);
    if (data && data.billingscheduledetails.length) {
      this.eventSchedule = data.billingscheduledetails;
    }
  }

  resetFormAutoFill(): void  {
    this.payorList = [];
    this.creditSelectedIdCtrl.patchValue(null);
    this.payoridlistCtrl.patchValue([]);
    this.billingstatusidlistCtrl.patchValue([]);
  }

  toogleValueBalanceLess(event: any): void {
    if (event.type === 'change') {
      if (this.balanceLessThan) {
        this.balanceLessThanValueCtrl.setValidators(Validators.required);
      } else {
        this.balanceLessThanValueCtrl.clearValidators();
      }

      this.balanceLessThanValueCtrl.patchValue(null);
      this.balanceLessThanValueCtrl.updateValueAndValidity();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/billing-general/posting/autofill-posting-batch/autofill-posting-batch.component.ts